import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

export default function NoData() {
  const { walletAddress } = useSelector((state) => state);

  return (
    <Flex justify='center' flexDirection='column' align='center'>
      {/* <Image src="/background/happy.png" alt="happy" h="100px" w="100px" /> */}

      <Box fontSize='20px' color='#8e8e91' mt='1rem'>
        {walletAddress ? 'No data to display' : 'Please connect wallet'}
      </Box>
    </Flex>
  );
}
